import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

import { AgGridReact } from 'ag-grid-react'
import 'ag-grid-community/styles/ag-grid.css'
import 'ag-grid-community/styles/ag-theme-alpine.css'
import 'ag-grid-enterprise'

function UserProfile({ loggedInUserId }) {
    const [userData, setUserData] = useState({});
    const [paymentData, setPaymentData] = useState([]);
    const [loading, setLoading] = useState(false);
    const gridRef = useRef();

    const columns = [
        { headerName: 'Id', filter: 'agNumberColumnFilter', width: 80, sortable: false, filter: false, valueGetter: (params) => { return params.node.rowIndex + 1; }, headerClass: 'custom-header-class' },
        { field: 'amount', headerName: 'Amount', filter: 'agNumberColumnFilter', width: 150, headerClass: 'custom-header-class', },
        { field: 'paymentmode', headerName: 'Payment Mode', filter: 'agTextColumnFilter', width: 150, headerClass: 'custom-header-class', },
        { field: 'noofcredits', headerName: 'Credits', filter: 'agNumberColumnFilter', width: 150, headerClass: 'custom-header-class', },
        { field: 'createddate', headerName: 'Date', filter: 'agDateColumnFilter', width: 200, headerClass: 'custom-header-class', },
    ];

    const sideBar = {
        toolPanels: [
            {
                id: 'columns',
                labelDefault: 'Columns',
                labelKey: 'columns',
                iconKey: 'columns',
                toolPanel: 'agColumnsToolPanel',
            },
            {
                id: 'filters',
                labelDefault: 'Filters',
                labelKey: 'filters',
                iconKey: 'filter',
                toolPanel: 'agFiltersToolPanel',
            }
        ],
        defaultToolPanel: '',
    };


    const datasource = {
        getRows: function (params) {
            const serverApiUrl = `/api/paymetsd/${loggedInUserId}`;

            fetch(serverApiUrl, {
                method: 'post',
                body: JSON.stringify({ ...params.request }),
                headers: { "Content-Type": "application/json; charset=utf-8", "Authorization": `Bearer ${sessionStorage.getItem('jwttoken')}` }
            })
                .then(httpResponse => httpResponse.json())
                .then(response => {
                    params.successCallback(response.rows, response.lastRow);
                })
                .catch(error => {
                    console.error(error);
                    params.failCallback();
                });
        },
    };

    useEffect(() => {
        gridRef.current.api?.refreshServerSide({ purge: true });
    }, [])

    const gridOptions = {
        rowModelType: 'serverSide',
        columnDefs: columns,

        defaultColDef: {
            sortable: true,
            filter: true,
            resizable: true,
            floatingFilter: false,
            enableValue: true,
            enableRowGroup: true,
            enablePivot: true,
            suppressMenu: true,
        },

        rowSelection: 'multiple',
        columnHoverHighlight: true,
        suppressRowGroupHidesColumns: true,
        cacheBlockSize: 50,
    }

    const onGridReady = (params) => {
        params.api.setServerSideDatasource(datasource);
    };

    useEffect(() => {
        if (!loggedInUserId) return;

        const fetchData = async () => {
            try {
                setLoading(true);
                const response = await axios.get(
                    `/paymetsdetails/${loggedInUserId}`
                );

                if (response.status === 200) {
                    console.log("response", response)
                    setPaymentData(response.data.result2 || []);
                    setUserData(response.data.result1?.[0] || {});
                }
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, [loggedInUserId]);

    const handleCancelSubscription = async () => {
        try {
            const confirmCancel = window.confirm(
                "Are you sure you want to cancel your subscription?"
            );
            if (!confirmCancel) return;

            const response = await axios.post(`/cancel-subscription`, { loggedInUserId });
            if (response.status === 200) {
                alert("Subscription cancelled successfully");

            }

            // Optional: refresh profile data
        } catch (error) {
            console.error("Cancel subscription failed", error);
            alert("Failed to cancel subscription");
        }
    };

    if (loading) {
        return <div className="text-center mt-4">Loading profile...</div>;
    }

    return (
        <div className="container mt-4">
            <div className="row">
                {/* LEFT: USER PROFILE */}
                <div className="col-md-4">
                    <div className="card shadow-sm mb-4">
                        <div className="card-header bg-primary text-white">
                            <h5 className="mb-0">User Profile</h5>
                        </div>
                        <div className="card-body">
                            <p><strong>Name:</strong> {userData.firstname} {userData.lastname}</p>
                            <p><strong>Company:</strong> {userData.company}</p>
                            <p><strong>Email:</strong> {userData.email}</p>
                            <p><strong>Contact:</strong> {userData.phone}</p>
                            <p>
                                <strong>Plan:</strong>{" "}
                                <span>
                                    {userData.plan}
                                    {userData.plan === "Premium" && (
                                        <i
                                            className="bi bi-x-circle"
                                            role="button"
                                            title="Cancel Subscription"
                                            onClick={handleCancelSubscription}
                                            style={{ cursor: "pointer", fontSize: "14px", marginLeft: "4px" }}
                                        />
                                    )}
                                </span>
                            </p>
                            {userData.billingcycle != null && (
                                <p>
                                    <strong>Billing Cycle:</strong>{" "}
                                    {userData.billingcycle === 1 ? "Monthly" : "Annual"}
                                </p>
                            )}


                            {/* <button
                                className="btn btn-danger w-100 mt-3"
                                onClick={handleCancelSubscription}
                                disabled={!userData.plan}
                            >
                                Cancel Subscription
                            </button> */}
                        </div>
                    </div>
                </div>

                {/* RIGHT: PAYMENT DETAILS */}
                <div className="col-md-8">
                    <div className="m-0 p-0 h-100 d-flex flex-row">
                        <div className="ag-theme-alpine border" style={{ height: "400px", width: "100%" }}>

                            <AgGridReact
                                ref={gridRef}
                                gridOptions={gridOptions}
                                onGridReady={onGridReady}
                                suppressContextMenu={true}
                            />
                        </div>

                    </div>
                    {/* <div className="card shadow-sm">
                        <div className="card-header bg-primary text-white">
                            <h5 className="mb-0">Payment History</h5>
                        </div>
                        <div className="card-body">
                            {paymentData.length === 0 ? (
                                <p className="text-muted text-center">
                                    No payment records found.
                                </p>
                            ) : (
                                <div className="table-responsive">
                                    <table className="table table-bordered table-hover align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th>ID</th>
                                                <th>Amount</th>
                                                <th>Payment Mode</th>
                                                <th>Credits</th>
                                                // <th>Date</th>
                                                //  <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {paymentData.map((item) => (
                                                <tr key={item.id}>
                                                    <td>{item.id}</td>
                                                    <td>₹ {item.amount}</td>
                                                    <td>{item.paymentmode}</td>
                                                    <td>{item.noofcredits}</td>
                                                    <td>
                                                        {new Date(item.createddate).toLocaleDateString()}
                                                    </td>
                                                    <td>
                                                        <span
                                                            className={`badge ${
                                                                item.isactive
                                                                    ? "bg-success"
                                                                    : "bg-secondary"
                                                            }`}
                                                        >
                                                            {item.isactive ? "Active" : "Inactive"}
                                                        </span>
                                                    </td> 
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            )}
                        </div>
                    </div> */}
                </div>

                {/* AG Grid*/}

            </div>
        </div>
    );
}

export default UserProfile;
